/**
 * Sanitize a filename by removing invalid characters
 *
 * @param {string} name - The filename to sanitize
 * @returns {string} Sanitized filename (max 200 chars)
 */
export function sanitizeFileName(name) {
    const input = (name || '').toString().trim();
    if (!input) return '';

    const invalid = '<>:"/\\|?*';
    let out = '';

    for (let i = 0; i < input.length && out.length < 200; i++) {
        const ch = input[i];
        const code = ch.charCodeAt(0);
        if (code < 32 || invalid.includes(ch)) {
            out += '_';
        } else {
            out += ch;
        }
    }

    return out;
}
